import React from "react";
import StatusChip from "./StatusChip";
import { VERIFICATION_REQUEST_STATUS } from "../../utils/enums";

interface Props {
  status: string;
}

const VerificationStatusChip: React.FC<Props> = ({ status }) => {
  switch (status) {
    case VERIFICATION_REQUEST_STATUS.NEW:
      return (
        <StatusChip tone="primary" icon="bi-send-fill" label="Submitted" />
      );
    case VERIFICATION_REQUEST_STATUS.INPROGRESS:
      return (
        <StatusChip
          tone="warning"
          icon="bi-arrow-repeat"
          label="In-Progress"
        />
      );
    case VERIFICATION_REQUEST_STATUS.RESOLVED:
      return (
        <StatusChip
          tone="success"
          icon="bi-check-circle-fill"
          label="Completed"
        />
      );
    default:
      return null;
  }
};

export default VerificationStatusChip;
